import React from "react";
import styles from "@/public/styles/pages/blog/category/content.module.scss";
import Link from "next/link";

const SubMenu = (props) => {
    let {categories, category} = props

    let isSubCategorySelected = false;
    let subCategories = categories.map(a => {return {...a}})

    subCategories.forEach((item) => {
        item.class = styles.defaule
        item.urlKey =  `/exercises/${item.urlKey}`

        if (category) {
            if (item._id == category._id) {
                item.class = styles.selected
                isSubCategorySelected = true
            }
        }
    })

    let allPostsItem = {
        _id: 'all-exercises',
        name: 'Все публикации',
        urlKey: '/exercises',
        class: styles.defaule
    }

    if (!isSubCategorySelected) {
        allPostsItem.class = styles.selected
    }

    subCategories.unshift(allPostsItem)

    return (
        <div className={styles.subMenu}>
            <div className={styles.subMenuList}>
                {subCategories?.map((category) => {
                        return (
                            <Link key={category._id} href={category.urlKey}><a
                                className={category.class}>{category.name}</a></Link>
                        );
                    }
                )}
            </div>
        </div>
    );
}

export default SubMenu